import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import createSimpleValidator from './createSimpleValidator';

const errorString = 'Vous devez entrer un numéro de téléphone mobile valide (format international accepté).';

const checkIsMobilePhoneNumber = createSimpleValidator(
    (value) => {
        if (typeof value !== 'string' || '' === value.trim()) {
            return null;
        }
        const normalizedValue = value.startsWith('+') ? value : `+${value}`;
        const phoneNumber = parsePhoneNumberFromString(normalizedValue);

        if (phoneNumber && phoneNumber.isValid()) {
            const { country } = phoneNumber;
            const type = phoneNumber.getType();
            if ('MOBILE' === type || (('CA' === country || 'US' === country) && 'FIXED_LINE_OR_MOBILE' === type)) {
                return true;
            }

            return false;
        }

        return null;
    },
    errorString,
);

export default checkIsMobilePhoneNumber;
